<template>
  <div :class="{'tableWithPerPageSelection' : showPerPage}">
    <div class="columns is-multiline level">
      <div class="column is-narrow level-left">
        <form @submit.prevent="recherche()">
          <b-input :placeholder="$t('general.button.search')"
                   type="search"
                   icon="magnify"
                   v-model="critereRecherche.auto">
          </b-input>
        </form>
      </div>
      <div class="column is-narrow level-right">
        <router-link-blank
          :to="{ name: 'm.logistique.ordre_travail-techAdd',
          params: { patrimoineId: idPatrimoine,
          typePatrimoine: typePatrimoine }}"
          :class="{'button-access-no-permission':
            !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.maj)}"
          :message="$t('detailEmplacement.actions.otTech')"
          classMessage="button is-addOrEdit"
          classComposant="noTextDecoration"/>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" ref="tableOrdreTravail"
                    class="displayNoneVuePagination"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering">
      <template slot='afterTable' v-if="showPerPage">
        <table-items-in-view @input="$refs.tableOrdreTravail.setLimit($event)"/>
      </template>
      <div slot="code" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.logistique.ordre_travail-tech', params: { id: props.row.id } }"
          class="lien"
          :message="props.row.code"
          :class="{'text-access-no-permission':
          !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.lecture)}">
        </router-link-blank>
      </div>
      <div slot="typeOt" slot-scope="props" >
        {{ getLibelleTypeIntervention(props.row.typeOtId )}}
      </div>
      <div slot="etat" slot-scope="props" >
        {{ getLibelleEtat(props.row.etat )}}
      </div>
      <div slot="technicien" slot-scope="props">
        {{ props.row.fournisseur ? props.row.fournisseur.nomCommercial : null }}
      </div>
      <div slot="dateSouhaitee" slot-scope="props" >
        {{ props.row.dateSouhaitee | formatDate }}
      </div>
      <div slot="datePlanification" slot-scope="props" >
        {{ props.row.datePlanification | formatDate }}
      </div>
      <div slot="dateRealisation" slot-scope="props" >
        {{ props.row.dateRealisation | formatDate }}
      </div>
      <div slot="patrimoine" slot-scope="props" v-if="props.row.otPatrimoine">
        <router-link-blank :to="getRouterLinkPatrimoine(props.row.otPatrimoine)"
                           :message="getLibellePatrimoine(props.row.otPatrimoine)"
                           typeIcon="is-primary" sizeIcon="is-small">
        </router-link-blank>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="description" slot-scope="props">
        {{ props.row.description}}
      </div>
      <div slot="createBy" slot-scope="props">
        {{  getUserName(props.row.creatorUserId)}}
      </div>
    </v-server-table>
  </div>
</template>

<script>

import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import TableItemsInView from '@/components/general/TableItemsInView';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { ORDRE_TRAVAIL as PERM_ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import messageErreur from '@/services/general/messageErreur';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { columnsSplice } from '@/services/general/columns';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const OT = createNamespacedHelpers('ordreTravailTech');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      startArrayRendering: false,
      constantes: {
        PERM_ORDRE_TRAVAIL,
      },
    };
  },
  components: {
    TableItemsInView,
    routerLinkBlank,
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
    idPatrimoine: {
      type: String,
      required: true,
    },
    typePatrimoine: {
      type: String,
      required: true,
    },
    showPerPage: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...OT.mapActions({
      loadOrdreTravail: 'loadOrdreTravail',
      setCritereRecherche: 'setCritereRecherche',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    getUserName(id) {
      const user = this.users.find(user => user.id === id);
      return user ? nomPrenomGetter(user) : 'Inconnu';
    },
    getLibelleTypeIntervention(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    recherche() {
      this.$refs.tableOrdreTravail.refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    getLibellePatrimoine(otPatrimoine) {
      if (otPatrimoine.faceId) return otPatrimoine.face.code + this.$t('listeOrdreTravailTech.tabs.typeFace');
      if (otPatrimoine.materielId) return otPatrimoine.materiel.code + this.$t('listeOrdreTravailTech.tabs.typeMateriel');
      if (otPatrimoine.dispositifId) return otPatrimoine.dispositif.code + this.$t('listeOrdreTravailTech.tabs.typeDispositif');
      if (otPatrimoine.emplacementId) return otPatrimoine.emplacement.code + this.$t('listeOrdreTravailTech.tabs.typeEmplacement');
      return null;
    },
    getRouterLinkPatrimoine(otPatrimoine) {
      if (otPatrimoine.faceId) {
        return {
          name: 'c.gabed.emplacement-face',
          params: {
            id: otPatrimoine.face.materiel.dispositif.emplacement.id,
            idFace: otPatrimoine.faceId,
          },
        };
      }
      if (otPatrimoine.materielId) {
        return {
          name: 'c.gabed.emplacement-detailMateriel',
          params: {
            id: otPatrimoine.materiel.dispositif.emplacement.id,
            idMateriel: otPatrimoine.materielId,
          },
        };
      }
      if (otPatrimoine.dispositifId) {
        return {
          name: 'c.gabed.emplacement-detailDispositif',
          params: {
            id: otPatrimoine.dispositif.emplacement.id,
            idDispositif: otPatrimoine.dispositifId,
          },
        };
      }
      if (otPatrimoine.emplacementId) {
        return {
          name: 'c.gabed.emplacement-detailEmplacement',
          params: {
            id: otPatrimoine.emplacementId,
          },
        };
      }
      return null;
    },
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  computed: {
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...OT.mapGetters({
      ordresTravail: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      const columns = ['code', 'typeOt', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'technicien', 'patrimoine', 'agence', 'description', 'createBy'];
      if (this.agencesSelectionnees.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      if (!this.showPerPage) texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeOrdreTravailTech.tabs.code'),
          etat: this.$t('listeOrdreTravailTech.tabs.etat'),
          typeOt: this.$t('listeOrdreTravailTech.tabs.type'),
          dateSouhaitee: this.$t('listeOrdreTravailTech.tabs.dateSouhaite'),
          datePlanification: this.$t('listeOrdreTravailTech.tabs.datePlanification'),
          dateRealisation: this.$t('listeOrdreTravailTech.tabs.dateRealisation'),
          patrimoine: this.$t('listeOrdreTravailTech.tabs.patrimoine'),
          agence: this.$t('listeOrdreTravailTech.tabs.agence'),
          technicien: this.$t('listeOrdreTravailTech.tabs.technicien'),
          description: this.$t('listeOrdreTravailTech.tabs.description'),
          createBy: this.$t('listeOrdreTravailTech.tabs.createBy'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (!data.query.agencesId || data.query.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadOrdreTravail(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.ordresTravail,
            count: this.totalCount,
          };
        }),
        sortable: ['code', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'montantHt'],
      };
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur)
        .filter(user => user.actif);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.critereRecherche.patrimoineIds = this.ids;
      this.startArrayRendering = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
